import api from './api';
import { Document } from '../types';

function safeDownloadBasename(name: string): string {
  const t = name.replace(/[/\\?*:|"<>]/g, '_').trim();
  return (t || 'document').slice(0, 200);
}

export const documentsService = {
  // Upload document
  async upload(data: FormData): Promise<Document> {
    const response = await api.post('/documents/upload', data);
    return response.data;
  },

  // Get document by ID
  async getById(id: string): Promise<Document> {
    const response = await api.get(`/documents/${id}`);
    return response.data;
  },

  // Delete document
  async delete(id: string): Promise<void> {
    await api.delete(`/documents/${id}`);
  },

  /** Saves the file locally (PDF and other types) via API proxy with Content-Disposition. */
  async downloadToDevice(id: string, filename: string): Promise<void> {
    const response = await api.get(`/documents/${id}/download`, {
      responseType: 'blob',
    });
    const rawType = response.headers['content-type'] as string | undefined;
    const type =
      rawType?.split(';')[0]?.trim() || 'application/octet-stream';
    const blob = new Blob([response.data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = safeDownloadBasename(filename);
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};
